<div *ngFor="let doc of params.data.attachment_urls" class="docContainer" [ngSwitch]="getDocTag(doc)">
    <img *ngSwitchCase="'pdf'" src="assets/images/icon_pdf.png" alt="" (click)="clickOnImage(doc)"/>
    <img *ngSwitchDefault src="{{doc}}" alt="" (click)="clickOnImage(doc)"/>   
</div>